import { APP_CONFIG } from "../constants/global-variables.js";

const BASE_URL = APP_CONFIG.URL.apiBasePath

export async function getGamesCategories() {
  const url = `${BASE_URL}vegas/categories`;
  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (err) {}
};

export async function getGameList() {
    const url = `${BASE_URL}vegas/list`;
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {}
};

export async function launchGame(gameID) {
    const url = `${BASE_URL}vegas/launch/${gameID}`;
    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {}
}
